// removed by extract-text-webpack-plugin
module.exports = {"btn":"DealerLocator-module-btn-1bKF0","btn-text":"DealerLocator-module-btn-text-25P7e","btnText":"DealerLocator-module-btn-text-25P7e","btn-icon":"DealerLocator-module-btn-icon-1mFLW","btnIcon":"DealerLocator-module-btn-icon-1mFLW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DealerLocator/DealerLocator.module.scss
// module id = 920
// module chunks = 0